(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations-default');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }

        translator.doTranslate(".product-recommendations-default");
        let value = $.cookie('showpriceInclVAT') === null ? defaultTaxView : $.cookie('showpriceInclVAT') == "true";
        updateVATincluded (value, true);
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations-default');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-suggested-items-auto"]) return;
  try {
    
  //Suggested products
  const handleIntersection = (entries, observer) => {
		if (!entries[0].isIntersecting) return;
		observer.unobserve(productRecommendationsSection);
		const url = productRecommendationsSection.dataset.url;
		fetch(url)
			.then(response => response.text())
			.then(text => {
				const html = document.createElement('div');
				html.innerHTML = text;
				const recommendations = html.querySelector('.product-recommendations');
				if (recommendations && recommendations.innerHTML.trim().length) {
					productRecommendationsSection.innerHTML = recommendations.innerHTML;
				}
                translator.doTranslate(".product-recommendations");
                let value = $.cookie('showpriceInclVAT') === null ? defaultTaxView : $.cookie('showpriceInclVAT') == "true";
                //let value = $.cookie('showpriceInclVAT') == "true";
                updateVATincluded (value, true);
			})
			.catch(e => {
				console.error(e);
			});
  };
  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recommended-products"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations-default');

        // SI on a des recommandations (le contenu n'est pas vide)
        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
          
          // On s'assure que c'est visible
          productRecommendationsSection.style.display = 'block';

          // Vos fonctions de traduction et de taxes
          if (typeof translator !== 'undefined' && typeof translator.doTranslate === 'function') {
             translator.doTranslate(".product-recommendations-default");
          }
          if (typeof updateVATincluded === 'function') {
             let value = $.cookie('showpriceInclVAT') === null ? defaultTaxView : $.cookie('showpriceInclVAT') == "true";
             updateVATincluded(value, true);
          }
        } 
        // SINON (Si c'est vide), on cache la section complètement
        else {
          productRecommendationsSection.style.display = 'none';
        }
      })
      .catch(e => {
        console.error(e);
        // En cas d'erreur technique, on cache aussi pour éviter un bloc vide moche
        productRecommendationsSection.style.display = 'none';
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations-default');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products-auto"]) return;
  try {
    
  //Suggested products
  const handleIntersection = (entries, observer) => {
		if (!entries[0].isIntersecting) return;
		observer.unobserve(productRelatedSection);
		const url = productRelatedSection.dataset.url;
		fetch(url)
			.then(response => response.text())
			.then(text => {
				const html = document.createElement('div');
				html.innerHTML = text;
				const related = html.querySelector('.product-related');
				if (related && related.innerHTML.trim().length) {
					productRelatedSection.innerHTML = related.innerHTML;
				}
                translator.doTranslate(".product-related");
                let value = $.cookie('showpriceInclVAT') === null ? defaultTaxView : $.cookie('showpriceInclVAT') == "true";
                //var value = $.cookie('showpriceInclVAT') == "true";
                updateVATincluded (value, true);
                SW.page.init();
			})
			.catch(e => {
				console.error(e);
			});
  };
  const productRelatedSection = document.querySelector('.product-related');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
  observer.observe(productRelatedSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow-with-filter"] && !Shopify.designMode) return;
  try {
    
  $('.filter-category').change(function() {
    var url = $(this).val();
    if (url) {
      window.location = url;
    }
    return false;
  });

  $('.filter-tag').change(function() {
    var url = $(this).val();
    if (url) {
      console.log(url);
      window.location = url;
    }
    return false;
  });

  } catch(e) { console.error(e); }
})();
})();
